import { render, staticRenderFns } from "./ColorCheckoutContainer.vue?vue&type=template&id=013a9f28"
import script from "./ColorCheckoutContainer.vue?vue&type=script&lang=js"
export * from "./ColorCheckoutContainer.vue?vue&type=script&lang=js"
import style0 from "./ColorCheckoutContainer.vue?vue&type=style&index=0&id=013a9f28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports